import { get, post } from '../../utils/http';

export const toolsReset = ({ accountId, email }) => post(`/accounts/${accountId}/ubeya-tools/admin-action`, { email });

export const fetchUserAction = ({ accountId }) => get(`/accounts/${accountId}/ubeya-tools/user-action`);
